import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { ReactComponent as ArrowDown } from "@/assets/icons/actions/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "@/assets/icons/actions/ArrowUp.svg";
// Libraries
import clsx from "clsx";
const SCROLL_THRESHOLD = 100;
export default function ScrollButton() {
	const [atBottom, setAtBottom] = useState(false);

	useEffect(() => {
		const onScroll = () => {
			const scrollTop = window.scrollY;
			const windowHeight = window.innerHeight;
			const documentHeight = document.documentElement.scrollHeight;

			if (scrollTop + windowHeight >= documentHeight - SCROLL_THRESHOLD) {
				setAtBottom(true);
			} else {
				setAtBottom(false);
			}
		};
		onScroll(); // Initial check
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	const scrollUp = atBottom;

	const handleClick = () => {
		window.scrollTo({
			top: scrollUp ? 0 : document.documentElement.scrollHeight,
			behavior: "smooth",
		});
	};

	return (
		<Button
			onClick={handleClick}
			disableRipple={true}
			color="primary"
			variant="contained"
			size="small"
			sx={{
				minWidth: 0,
				width: 38,
				height: 30,
				p: 1,
				alignItems: "center",
				justifyContent: "center",
			}}
			className={clsx({
				"!rounded-md !h-[30px] !font-normal !text-[14px] !shadow-none": true,
				"!bg-primary hover:!shadow-primary-shadow-50": true,
				" !text-white": true,
			})}
		>
			<span>{scrollUp ? <ArrowUp /> : <ArrowDown />}</span>
		</Button>
	);
}
